// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary: #1DB954;
  --primary-rgb: 29,185,84;
  --secondary: #2563EB;
  --secondary-rgb: 37,99,235;
  --background: #ffffff;
  --foreground: #1a2236;
  --foreground-rgb: 26,34,54;
  --muted: #f8fafc;
  --muted-foreground: #6b7280;
  --muted-foreground-rgb: 107,114,128;
  --border: #e5e7eb;
  --border-rgb: 229,231,235;
  --success: #10b981;
  --success-rgb: 16,185,129;
  --danger: #c0392b;
  --danger-rgb: 192,57,43;
  --info: #2874f0;
  --info-rgb: 40,116,240;
}

/* Global base */
html, body, #root {
  height: 100%;
}
body {
  margin: 0;
  font-family: 'Inter', sans-serif;
  background: var(--background);
  color: var(--foreground);
}

/* Common utilities used across components */
.text-muted-foreground { color: var(--muted-foreground); }
.text-primary { color: var(--primary); }
.text-success { color: var(--success); }
.text-danger { color: var(--danger); }
.text-info { color: var(--info); }
.text-foreground { color: var(--foreground); }

.bg-muted { background: var(--muted); }
.bg-success { background: var(--success); }
.bg-info { background: linear-gradient(90deg,var(--info),var(--info)); }

.border-border { border-color: var(--border); }

.btn-primary {
  background: linear-gradient(45deg, var(--primary), var(--secondary));
  color: #fff;
  border: none;
  padding: 0.75rem 1.25rem;
  border-radius: 0.75rem;
  font-weight: 600;
  transition: all 0.3s;
  cursor: pointer;
  text-decoration: none;
}

.btn-primary:hover {
  box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04);
  transform: scale(1.05);
}

.btn-primary:disabled {
  background: var(--muted-foreground);
  cursor: not-allowed;
  transform: none;
}

/* Outline button used on Home hero */
.btn-outline {
  border: 2px solid var(--primary);
  color: var(--primary);
  background: transparent;
  font-weight: 600;
  padding: 1rem 2rem;
  border-radius: 0.75rem;
  cursor: pointer;
  transition: all 0.25s ease;
}
.btn-outline:hover { background: var(--primary); color: white; }

/* Badge utilities */
.badge {
  background: rgba(var(--border-rgb), 0.95);
  backdrop-filter: blur(6px);
  color: var(--foreground);
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 500;
}
.badge.active { background: var(--success); color: white; }
.badge.funding { background: var(--secondary); color: white; }
.badge.sold { background: #6b7280; color: white; }

/* Metric utilities */
.metric { text-align: center; }
@media (min-width: 1024px) { .metric { text-align: left; } }
.metric-value { font-size: 2rem; font-weight: 700; color: var(--foreground); display: block; margin-bottom: 8px; }
.metric-label { font-size: 1rem; font-weight: 500; color: var(--muted-foreground); }

/* Progress bar */
.progress-funded {
  height: 10px;
  background: rgba(var(--border-rgb), 0.6);
  border-radius: 999px;
  overflow: hidden;
  border: 1px solid var(--border);
}
.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--primary), var(--secondary));
  border-radius: 999px;
  transition: width 0.6s ease;
}

/* Basic container widths used across pages */
.max-w-7xl { max-width: 1280px; }
.mx-auto { margin-left: auto; margin-right: auto; }
.px-4 { padding-left: 16px; padding-right: 16px; }
.sm\\:px-6 { padding-left: 24px; padding-right: 24px; }
.lg\\:px-8 { padding-left: 32px; padding-right: 32px; }

/* Card base */
.card {
  background: var(--background);
  border-radius: 12px;
  padding: 1.25rem;
  box-shadow: 0 4px 16px rgba(0,0,0,0.08);
  border: 1px solid var(--border);
}
`, "",{"version":3,"sources":["webpack://./src/styles/theme.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,0BAA0B;EAC1B,qBAAqB;EACrB,qBAAqB;EACrB,0BAA0B;EAC1B,gBAAgB;EAChB,2BAA2B;EAC3B,mCAAmC;EACnC,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,YAAY;AACd;AACA;EACE,SAAS;EACT,gCAAgC;EAChC,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA,4CAA4C;AAC5C,yBAAyB,8BAA8B,EAAE;AACzD,gBAAgB,qBAAqB,EAAE;AACvC,gBAAgB,qBAAqB,EAAE;AACvC,eAAe,oBAAoB,EAAE;AACrC,aAAa,kBAAkB,EAAE;AACjC,mBAAmB,wBAAwB,EAAE;;AAE7C,YAAY,wBAAwB,EAAE;AACtC,cAAc,0BAA0B,EAAE;AAC1C,WAAW,0DAA0D,EAAE;;AAEvE,iBAAiB,2BAA2B,EAAE;;AAE9C;EACE,oEAAoE;EACpE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,+EAA+E;EAC/E,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,gCAAgC;EAChC,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,0BAA0B;AAC5B;AACA,qBAAqB,0BAA0B,EAAE,YAAY,EAAE;;AAE/D,oBAAoB;AACpB;EACE,yCAAyC;EACzC,0BAA0B;EAC1B,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA,gBAAgB,0BAA0B,EAAE,YAAY,EAAE;AAC1D,iBAAiB,4BAA4B,EAAE,YAAY,EAAE;AAC7D,cAAc,mBAAmB,EAAE,YAAY,EAAE;;AAEjD,qBAAqB;AACrB,UAAU,kBAAkB,EAAE;AAC9B,6BAA6B,UAAU,gBAAgB,EAAE,EAAE;AAC3D,gBAAgB,eAAe,EAAE,gBAAgB,EAAE,wBAAwB,EAAE,cAAc,EAAE,kBAAkB,EAAE;AACjH,gBAAgB,eAAe,EAAE,gBAAgB,EAAE,8BAA8B,EAAE;;AAEnF,iBAAiB;AACjB;EACE,YAAY;EACZ,wCAAwC;EACxC,oBAAoB;EACpB,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,oEAAoE;EACpE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA,6CAA6C;AAC7C,aAAa,iBAAiB,EAAE;AAChC,WAAW,iBAAiB,EAAE,kBAAkB,EAAE;AAClD,QAAQ,kBAAkB,EAAE,mBAAmB,EAAE;AACjD,YAAY,kBAAkB,EAAE,mBAAmB,EAAE;AACrD,YAAY,kBAAkB,EAAE,mBAAmB,EAAE;;AAErD,cAAc;AACd;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;EACvC,+BAA+B;AACjC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');\n\n:root {\n  --primary: #1DB954;\n  --primary-rgb: 29,185,84;\n  --secondary: #2563EB;\n  --secondary-rgb: 37,99,235;\n  --background: #ffffff;\n  --foreground: #1a2236;\n  --foreground-rgb: 26,34,54;\n  --muted: #f8fafc;\n  --muted-foreground: #6b7280;\n  --muted-foreground-rgb: 107,114,128;\n  --border: #e5e7eb;\n  --border-rgb: 229,231,235;\n  --success: #10b981;\n  --success-rgb: 16,185,129;\n  --danger: #c0392b;\n  --danger-rgb: 192,57,43;\n  --info: #2874f0;\n  --info-rgb: 40,116,240;\n}\n\n/* Global base */\nhtml, body, #root {\n  height: 100%;\n}\nbody {\n  margin: 0;\n  font-family: 'Inter', sans-serif;\n  background: var(--background);\n  color: var(--foreground);\n}\n\n/* Common utilities used across components */\n.text-muted-foreground { color: var(--muted-foreground); }\n.text-primary { color: var(--primary); }\n.text-success { color: var(--success); }\n.text-danger { color: var(--danger); }\n.text-info { color: var(--info); }\n.text-foreground { color: var(--foreground); }\n\n.bg-muted { background: var(--muted); }\n.bg-success { background: var(--success); }\n.bg-info { background: linear-gradient(90deg,var(--info),var(--info)); }\n\n.border-border { border-color: var(--border); }\n\n.btn-primary {\n  background: linear-gradient(45deg, var(--primary), var(--secondary));\n  color: #fff;\n  border: none;\n  padding: 0.75rem 1.25rem;\n  border-radius: 0.75rem;\n  font-weight: 600;\n  transition: all 0.3s;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.btn-primary:hover {\n  box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04);\n  transform: scale(1.05);\n}\n\n.btn-primary:disabled {\n  background: var(--muted-foreground);\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Outline button used on Home hero */\n.btn-outline {\n  border: 2px solid var(--primary);\n  color: var(--primary);\n  background: transparent;\n  font-weight: 600;\n  padding: 1rem 2rem;\n  border-radius: 0.75rem;\n  cursor: pointer;\n  transition: all 0.25s ease;\n}\n.btn-outline:hover { background: var(--primary); color: white; }\n\n/* Badge utilities */\n.badge {\n  background: rgba(var(--border-rgb), 0.95);\n  backdrop-filter: blur(6px);\n  color: var(--foreground);\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n.badge.active { background: var(--success); color: white; }\n.badge.funding { background: var(--secondary); color: white; }\n.badge.sold { background: #6b7280; color: white; }\n\n/* Metric utilities */\n.metric { text-align: center; }\n@media (min-width: 1024px) { .metric { text-align: left; } }\n.metric-value { font-size: 2rem; font-weight: 700; color: var(--foreground); display: block; margin-bottom: 8px; }\n.metric-label { font-size: 1rem; font-weight: 500; color: var(--muted-foreground); }\n\n/* Progress bar */\n.progress-funded {\n  height: 10px;\n  background: rgba(var(--border-rgb), 0.6);\n  border-radius: 999px;\n  overflow: hidden;\n  border: 1px solid var(--border);\n}\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, var(--primary), var(--secondary));\n  border-radius: 999px;\n  transition: width 0.6s ease;\n}\n\n/* Basic container widths used across pages */\n.max-w-7xl { max-width: 1280px; }\n.mx-auto { margin-left: auto; margin-right: auto; }\n.px-4 { padding-left: 16px; padding-right: 16px; }\n.sm\\:px-6 { padding-left: 24px; padding-right: 24px; }\n.lg\\:px-8 { padding-left: 32px; padding-right: 32px; }\n\n/* Card base */\n.card {\n  background: var(--background);\n  border-radius: 12px;\n  padding: 1.25rem;\n  box-shadow: 0 4px 16px rgba(0,0,0,0.08);\n  border: 1px solid var(--border);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
